import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Configuration Firebase
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Vérifier que toutes les variables d'environnement sont définies
const requiredEnvVars = [
  'REACT_APP_FIREBASE_API_KEY',
  'REACT_APP_FIREBASE_AUTH_DOMAIN',
  'REACT_APP_FIREBASE_PROJECT_ID',
  'REACT_APP_FIREBASE_STORAGE_BUCKET',
  'REACT_APP_FIREBASE_MESSAGING_SENDER_ID',
  'REACT_APP_FIREBASE_APP_ID'
];

requiredEnvVars.forEach(varName => {
  if (!process.env[varName]) {
    console.error(`Variable d'environnement manquante: ${varName}`);
    console.log('Valeur actuelle:', process.env[varName]);
  }
});

// Initialiser Firebase
let app;
try {
  app = initializeApp(firebaseConfig);
  console.log('Firebase initialisé avec succès');
  console.log('Configuration Firebase:', {
    ...firebaseConfig,
    apiKey: '***' // Ne pas afficher la clé API complète
  });
} catch (error) {
  console.error('Erreur d\'initialisation Firebase:', error);
  throw error;
}

// Initialiser Firestore
const db = getFirestore(app);

// Initialiser Auth
const auth = getAuth(app);

export { db, auth };
